module.exports = "/assets/14f6a123954cd6c0a501059876bb4886.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WO.png
// module id = 1967
// module chunks = 0